import {reactive, computed, ref, inject} from 'vue';

import FormInputComponent from '@/components/_shared/_partials/form-input/form-input.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRectangleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faRectangleXmark);

export default {
  name: 'AuthLoginComponent',
  components: { FormInputComponent, FontAwesomeIcon},
  props: {
    resetMessage: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup() {

    const authProvider = inject('authProvider')
    const config = inject('config')

    const state = reactive({
      username: ref(null),
      password: ref(null),
      reset: ref(null),
      showReset: ref(false),
      update: async (data) => {
        const { key, value } = data;
        state[key] = value;
      },
      canSubmit: computed(() => {
        const { username, password } = state;
        return Boolean(username && password);
      }),
      validReset: computed(() => {
        const { reset } = state;
        return reset ? validateEmail(reset) : false;
      }),
      resetMessage: ref(null),
    });

    const validateEmail = (email) => {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    };

    const resetEmail = async () => {
      let email = state.reset
      const response = await authProvider().initiatePasswordReset(email, config);
      if (response.status === 'success') {
        console.log('resetEmail response', response);
        state.resetMessage = 'Request recieved. If that email address is in our database, we will send you an email to reset your password.';
      } else {
        state.resetMessage = 'Your submitted user email could not be processed by our system. Please contact customer service.';
      }
    }

    return { state, resetEmail };
  },
  methods: {
    login: async function () {
      const { username, password } = this.state;
      this.$emit('login', { username, password });
    },
    loginOnEnter: async function () {
      if (this.state.canSubmit) {
        await this.login();
      }
    },
    resetOnEnter: async function () {
      if (this.state.validReset) {
        await this.resetEmail();
      }
    },
  }
};
